import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container, Sprite, useTick } from '@pixi/react';
import * as PIXI from 'pixi.js';
import { useCallback, useMemo, useRef } from 'react';
import { shallowEqual } from 'react-redux';
import LOADING_SPINNER_IMAGE_URL from '../../../assets/loading-spinner.png';
import { useAppSelector } from '../../../redux/store';
const LOADING_SPINNER_TEXTURE_SIZE = 512;
export const LoadingSeatAnimation = ({ seatIndex }) => {
    const bounds = useAppSelector((state) => state.gameDimensions.allSeatBounds[seatIndex], shallowEqual);
    const containerRef = useRef(null);
    const texture = useMemo(() => PIXI.Texture.from(LOADING_SPINNER_IMAGE_URL), []);
    const animate = useCallback((delta) => {
        if (!containerRef.current) {
            return;
        }
        containerRef.current.angle = ((containerRef.current.angle || 0) + delta * 2) % 360;
    }, []);
    useTick(animate);
    const renderSize = Math.min(bounds.w, bounds.h) / 3;
    const scale = renderSize / LOADING_SPINNER_TEXTURE_SIZE;
    return (_jsx(Container, { ref: containerRef, scale: scale, children: _jsx(Sprite, { texture: texture, x: -LOADING_SPINNER_TEXTURE_SIZE / 2, y: -LOADING_SPINNER_TEXTURE_SIZE / 2 }) }));
};
